<template>
  <div class="container main clearfix">
    <slot></slot>
  </div>
</template>
<style scoped>
.container {
  width: 1000px;
  margin: 0 auto;
}

@media screen and (min-width: 1160px) {
  .container {
    width: 1160px;
  }
}
</style>
